import React from "react"
import EMRFileUpload from "./EMRFileUpload"
import IssueRow from "./IssueRow"

const TableRow = ({ issue, isSelected, selectIssue, deselectIssue, openInSameTab }) => {

  const toggleSelectIssue = () => {
    if (!isSelected) {
      selectIssue(issue)
    } else {
      deselectIssue(issue)
    }
  }

  const onNavigate = (issue) => {
    const { origin, pathname, } = window.location
    if (issue?.id) {
      const url = `${origin + pathname}/${issue.id}`
      if (openInSameTab) {
        window.location.assign(url)
      } else {
        window.open(url, "_blank", "noopener=true,noreferrer=100")
      }
    }
  }

  return (
    <>
      {issue.issue_type === 'patient_file_upload' ? (
          <EMRFileUpload issue={issue} onNavigate={onNavigate} />
        ) :
        <IssueRow issue={issue} isSelected={isSelected} toggleSelectIssue={toggleSelectIssue} onNavigate={onNavigate} />
      }
    </>
  )
}

export default TableRow
